import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import React, { memo } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { AxiosResponse } from "axios";
import { AddIcon, RemoveICon } from "../../../../Shared/Icons";
import CreateExtractionService from "../../../../Services/InfectiousDisease/CreateExtractionService";
import InnerSectionExtractionRacksScanningLog from "./ExtractionRacksScanningLogInnerSection";
import useLang from "Shared/hooks/useLanguage";

const Row = (props: { row: any; index: number; loadGridData: any }) => {
  const { row, loadGridData } = props;

  const { t } = useLang();
  const [open, setOpen] = React.useState(false);

  // ===============================
  // BASE64 → EXCEL DOWNLOAD (FIXED)
  // ===============================
  const base64ToExcel = (base64: string, filename: string) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${filename}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // *********** React Query for Export / Download using React Query mutation ***********
  const downloadRackDetailsByIdMutation = useMutation<any, any, number>({
    mutationFn: (rackDetailId: number) =>
      CreateExtractionService.ExportRackPlateDetailsById(rackDetailId),

    onSuccess: (res: AxiosResponse) => {
      if (res?.data?.statusCode === 200) {
        toast.success(t(res?.data?.message));
        base64ToExcel(res.data.data.fileContents, "RackDetails");
      } else {
        toast.error(t(res?.data?.message));
      }
    },
  });

  const downloadRackDetailsById = (rackDetailId: number) => {
    downloadRackDetailsByIdMutation.mutate(rackDetailId);
  };
  // *********** React Query for Export / Download using React Query mutation ***********

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell className="text-center">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            className="btn btn-icon btn-icon-light btn-sm fw-bold btn-table-expend-row rounded h-20px w-20px min-h-20px"
          >
            {open ? (
              <button
                id={`IDCreateExtractionExpandClose_${row.rackDetailId}`}
                className="btn btn-icon btn-icon-light btn-sm fw-bold btn-table-expend-row rounded h-20px w-20px min-h-20px"
              >
                <RemoveICon />
              </button>
            ) : (
              <button
                id={`IDCreateExtractionExpandOpen_${row.rackDetailId}`}
                className="btn btn-icon btn-icon-light btn-sm fw-bold btn-primary rounded h-20px w-20px min-h-20px"
              >
                <AddIcon />
              </button>
            )}
          </IconButton>
        </TableCell>

        <TableCell>
          <div className="d-flex justify-content-center">
            <div className="rotatebtnn">
              <DropdownButton
                className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
                key="end"
                id={`IDCreateExtractionDots_${row.rackDetailId}`}
                drop="end"
                title={<i className="bi bi-three-dots-vertical p-0"></i>}
              >
                <Dropdown.Item
                  id={`IDCreateExtractionDownload_${row.rackDetailId}`}
                  className="w-auto"
                  eventKey="3"
                  onClick={() => downloadRackDetailsById(row.rackDetailId)}
                >
                  <i className="fa fa-download text-danger"></i>
                  Download
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </div>
        </TableCell>

        <TableCell
          id={`IDCreateExtractionRackName_${row.rackDetailId}`}
          scope="row"
        >
          <span className="px-2">{row?.rackName}</span>
        </TableCell>

        <TableCell
          id={`IDCreateExtractionRackID_${row.rackDetailId}`}
          scope="row"
        >
          <span className="px-2">{row?.rackID}</span>
        </TableCell>

        <TableCell
          id={`IDCreateExtractionDateOfCreation_${row.rackDetailId}`}
          scope="row"
        >
          <span className="px-2">{row?.createdDate}</span>
        </TableCell>

        <TableCell
          id={`IDCreateExtractionCreatedby_${row.rackDetailId}`}
          scope="row"
        >
          <span className="px-2">{row?.createdBy}</span>
        </TableCell>

        <TableCell
          id={`IDCreateExtractionRackStatus_${row.rackDetailId}`}
          scope="row"
        >
          <span className="px-2">{row?.rackStatus}</span>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={7} className="padding-0">
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography gutterBottom component="div">
                <div className="table-expend-sticky">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xxl-12 px-lg-14 px-md-10 px-4">
                      <InnerSectionExtractionRacksScanningLog
                        innerRow={row.listIDLISRackPlate}
                        setOpen={setOpen}
                        loadGridData={loadGridData}
                      />
                    </div>
                  </div>
                </div>
              </Typography>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default memo(Row);
